import { render, staticRenderFns } from "./DataExamine.vue?vue&type=template&id=35b44656&scoped=true"
import script from "./DataExamine.vue?vue&type=script&lang=js"
export * from "./DataExamine.vue?vue&type=script&lang=js"
import style0 from "./DataExamine.vue?vue&type=style&index=0&id=35b44656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b44656",
  null
  
)

export default component.exports